import { ALL_MODULES, DateTimeFormatter, SecureText } from '@nile/components';
import { Button, TextStyle } from '@superops/ui-design-system';
import { isEmpty } from 'lodash';
import React from 'react';

const DisplayCell = ({ value, uiDataType, fieldName, clientId }) => {
  switch (uiDataType) {
    case 'date':
    case 'datetime':
      return (
        <DateTimeFormatter
          type={uiDataType === 'datetime' ? 'dateTime' : uiDataType}
          date={value}
        />
      );
    case 'url':
      return (
        <Button plain external url={value?.url}>
          {value?.text || value?.url}
        </Button>
      );

    case 'checkbox':
    case 'radio':
      if (Array.isArray(value) && value.length > 0) {
        return (
          <>
            {value.map((el, idx) => {
              const isLastElement = idx === value.length - 1;
              return (
                <TextStyle key={idx}>
                  {el}
                  {!isLastElement && ', '}
                </TextStyle>
              );
            })}
          </>
        );
      }
      return <TextStyle variation="subdued">NA</TextStyle>;
    case 'secure_text':
      return (
        <SecureText
          defaultValue={value}
          updateSelection={() => {}}
          value={value}
          field={{
            name: fieldName,
            uiDataType
          }}
          editable={false}
          module={ALL_MODULES.client}
          entityId={clientId}
          inlineEdit
        />
      );

    default:
      return <TextStyle>{value}</TextStyle>;
  }
};

const CustomFieldCell = (props) => {
  const cell = props?.cell;
  const field = cell?.column?.field;
  const clientId = cell?.row?.original?.accountId;
  const fieldName = field?.name;
  const customFieldsData = cell?.row?.original?.customFields;
  const uiDataType = field?.uiDataType;
  const value = customFieldsData?.[fieldName];

  if (isEmpty(value)) {
    return <TextStyle variation="subdued">NA</TextStyle>;
  }

  return (
    <div className="ellipsis">
      <DisplayCell
        value={value}
        uiDataType={uiDataType}
        fieldName={fieldName}
        clientId={clientId}
      />
    </div>
  );
};

export default CustomFieldCell;
